import { invalidateMinicart } from "~/app/store/bffApi";
import { getCsrfValue } from "~/common/utils/ApiHelper";
import { occBaseSiteUrl } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import { ApiCallPriority, apiPOST } from "~/app/api/apiCallsService";
import { transformUpdateApiItem, type UpdatePackageEntryItem } from "~/features/cart/cart/api/UpdatePackageEntry";
import { registerCallProcessor, scheduleCall } from "~/features/cart/cart/api/CartService";
import { naiveTrackCartContents } from "~/app/analytics/ga/abandonment";
import { getCurrentBrowserTimezone } from "~/common/utils/dateUtils";
import { resolveActiveCartResourceId } from "~/features/cart/cart/utils/cartResourceIdentity";

export function sendDelete(item: UpdatePackageEntryItem) {
  return sendBulkDelete([item]);
}

export function sendBulkDelete(items: UpdatePackageEntryItem[]) {
  return scheduleCall("delete", { items });
}

registerCallProcessor({
  type: "delete",
  canBeExecuted: (ongoingCalls) => {
    const areCallsOngoing = ongoingCalls.length > 0;
    return !areCallsOngoing;
  },
  execute: async ({ items }: { items: UpdatePackageEntryItem[] }) => {
    const body = {
      items: items.map((item) => transformUpdateApiItem(item)),
      userTimeZone: getCurrentBrowserTimezone(),
    };

    const result = await apiPOST(
      await resolveBulkDeleteApiUrl(),
      {
        body: JSON.stringify(body),
        cache: "no-cache",
        headers: {
          dataType: "json",
          "content-type": "application/json",
          CSRFToken: getCsrfValue(),
        },
        redirect: "follow",
      },
      { priority: ApiCallPriority.HIGH, skipParallelLimit: true },
    );
    invalidateMinicart();
    naiveTrackCartContents();
    return result;
  },
});

export async function resolveBulkDeleteApiUrl(): Promise<string> {
  const activeCartId = await resolveActiveCartResourceId();
  if (!activeCartId) {
    throw new Error("Cannot delete cart entries without an explicit Active Cart identity");
  }
  return occBaseSiteUrl(`${occCartUserPath()}/carts/${encodeURIComponent(activeCartId)}/entries/bulk-delete`);
}
